// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-traveler-forgot-travelerForgotCard-module__flexCenter--QAAIZ {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.src-js-traveler-forgot-travelerForgotCard-module__marginTop20--AWaVo {
  margin-top: 20px;
}

.src-js-traveler-forgot-travelerForgotCard-module__paddingY20--xCSkR {
  padding-top: 20px;
  padding-bottom: 20px;
}

.src-js-traveler-forgot-travelerForgotCard-module__textAlignCenter--XtGjI {
  text-align: center;
}

.src-js-traveler-forgot-travelerForgotCard-module__forgotError--oTw0l {
  display: flex;
  justify-content: center;
  span{
    color: #BA1B23;
    font-size: 1rem;
    margin-bottom: 1rem;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/js/traveler/forgot/travelerForgotCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".flexCenter {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.marginTop20 {\n  margin-top: 20px;\n}\n\n.paddingY20 {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.textAlignCenter {\n  text-align: center;\n}\n\n.forgotError {\n  display: flex;\n  justify-content: center;\n  span{\n    color: #BA1B23;\n    font-size: 1rem;\n    margin-bottom: 1rem;\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexCenter": `src-js-traveler-forgot-travelerForgotCard-module__flexCenter--QAAIZ`,
	"marginTop20": `src-js-traveler-forgot-travelerForgotCard-module__marginTop20--AWaVo`,
	"paddingY20": `src-js-traveler-forgot-travelerForgotCard-module__paddingY20--xCSkR`,
	"textAlignCenter": `src-js-traveler-forgot-travelerForgotCard-module__textAlignCenter--XtGjI`,
	"forgotError": `src-js-traveler-forgot-travelerForgotCard-module__forgotError--oTw0l`
};
export default ___CSS_LOADER_EXPORT___;
